"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaperStyled = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      backgroundColor: function backgroundColor(_ref) {
        var color = _ref.color;
        return color ? color : theme.palette.primary;
      },
      borderBottom: function borderBottom(_ref2) {
        var borderbottom = _ref2.borderbottom;
        return borderbottom;
      },
      borderRadius: "1rem;",
      boxShadow: "0 1.5rem 5rem 0 rgba(34, 34, 34, 0.08);",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
      padding: function padding(_ref3) {
        var _padding = _ref3.padding;
        return _padding ? _padding : "1.625rem 2rem;";
      }
    }
  };
})(_Paper.default);
var _default = PaperStyled;
exports.default = _default;